/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Apa_S6Inputs */

const en_tut_apa_s6 = /** @type {(inputs: Tut_Apa_S6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Meetings, Documents, and Whiteboards** complete it: calls with transcripts, documents you can export in seven formats, and a shared drawing canvas whose permissions follow whatever it belongs to.`)
};

const id_tut_apa_s6 = /** @type {(inputs: Tut_Apa_S6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Rapat, Dokumen, dan Papan tulis** melengkapinya: panggilan dengan transkrip, dokumen yang bisa diunduh dalam tujuh format, dan kanvas gambar bersama yang izinnya mengikuti induknya.`)
};

/**
* | output |
* | --- |
* | "**Meetings, Documents, and Whiteboards** complete it: calls with transcripts, documents you can export in seven formats, and a shared drawing canvas whose pe..." |
*
* @param {Tut_Apa_S6Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_apa_s6 = /** @type {((inputs?: Tut_Apa_S6Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Apa_S6Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_apa_s6(inputs)
	return en_tut_apa_s6(inputs)
});